<template>
    <PageForm :url="url" :model="model" :errors="errors" v-on:save="savePage"></PageForm>
</template>

<script>
import PageForm from './PageForm'
export default {
  name: 'PageCreate',
  components: {PageForm},
  props: ['url'],
  data () {
    return {
      model: {
        author_id: null,
        selectables: {
          authors: [],
          categories: []
        }
      },
      errors: {}
    }
  },
  methods: {
    savePage () {
      let self = this

      this.$http
        .post(this.url + `/create`, this.model, {
          'headers': {
            'Authorization': 'Bearer ' + localStorage.getItem('token'),
            'language': this.$store.state.loading.language
          }
        }).then(res => {
          if (res.data && res.data.data !== 'undefined') {
            self.model = res.data.data
            this.$router.push('/admin/pages/index')
          } else {
            this.errors = res.response.data.errors
          }
        }).catch(res => {

        })
    }
  },
  created: function () {
    this.$emit('updateTitle', this.$translate.t('Page Create'))

    let self = this
    this.$http
      .get(this.url + `/show/0`, {
        'headers': {
          'Authorization': 'Bearer ' + localStorage.getItem('token'),
          'language': this.$store.state.loading.language
        }
      }).then(res => {
        self.model = res.data.data
      }).catch(res => {

      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/page/PageCreate.vue